import React from "react";
import { graphql, QueryRenderer } from "react-relay";
import environment from "./Environment";
import { GC_USER_ID } from "./constants";
import AddSourcePage from "./AddSourcePage";
import { createOperationDescriptor, getRequest } from "relay-runtime";
import ThemeProvider from "./contexts/ThemeContext";

const userDetailsQuery = graphql`
	query AddSourcePageContainer_UserDetails_Query($id: ID!) {
		user(id: $id) {
			email
			is_premium
			is_active
            first_time_user
		}
		settings {
			isAuthenticated
			userId
			isNavActivated
			selectedSourceId
			selectedParentId
			treeStates
			selectedNodeId
			isParent

			sourceString
			categoryId
			isFullScreenAddSourceModalActivated
			isFullSpanSourceSearchModalActivated
            isAddSourcePageActivated
            isAddFeedBoxShown
		}
	}
`;

function AddSourcePageContainer(props) {
	let userId = localStorage.getItem(GC_USER_ID);

	return (
		<QueryRenderer
			environment={environment}
			query={userDetailsQuery}
			variables={{ id: userId }}
			render={({ error, props }) => {
				if (error) throw error;
				if (!props) return <div> ...Loading </div>;
				return (
					<div>
						<ThemeProvider>
							<AddSourcePage
								user={props.user}
								settings={props.settings}
							/>
						</ThemeProvider>
					</div>
				);
			}}
		/>
	);
}

export default AddSourcePageContainer;
